import { render, staticRenderFns } from "./RegisterDialog.vue?vue&type=template&id=11640f04&scoped=true"
import script from "./RegisterDialog.vue?vue&type=script&lang=js"
export * from "./RegisterDialog.vue?vue&type=script&lang=js"
import style0 from "./RegisterDialog.vue?vue&type=style&index=0&id=11640f04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11640f04",
  null
  
)

export default component.exports